@if (isDescriptorsPropagationView) {
    <div class="modal-body">
        <div class="row mb-3">
            <div class="col-sm-12">
                <div class="form-check form-check-inline">
                    <input type="checkbox" class="form-check-input" [(ngModel)]="propagateDescriptors" id="propagateDescriptors" name="propagateDescriptors">
                    <label class="form-check-label fw-bold" for="propagateDescriptors" jhiTranslate="advance-study.attributes.propagate.descriptors"></label>
                </div>
            </div>
        </div>
        <div class="border-top mb-3"></div>
        <div class="row mb-3">
            <div class="col-3">
                <div class="form-check form-check-inline">
                    <input [disabled]="!propagateDescriptors" type="checkbox" class="form-check-input" id="loadSavedSettings" [(ngModel)]="loadSavedSettings" name="loadSavedSettings">
                    <label class="form-check-label fw-bold" for="loadSavedSettings" jhiTranslate="advance-study.attributes.preset.load.settings"></label>
                </div>
            </div>
            <div class="col-sm-8">
                <select [disabled]="!loadSavedSettings || !propagateDescriptors" class="form-select" [(ngModel)]="templateId" (ngModelChange)="applySelectedSetting()">
                    <option [value]="0" jhiTranslate="global.please.choose">Please Choose</option>
                    <option *ngFor="let template of templates" [value]="template.templateId">{{template.templateName}}</option>
                </select>
            </div>
            <div class="col-sm-1">
                <button class="btn btn-info me-2" [disabled]="!propagateDescriptors || !loadSavedSettings ||  templateId===0" (click)="deleteSelectedSetting()">
                    <i class="fa fa-trash fa-md" aria-hidden="true"></i>
                </button>
            </div>
        </div>
        <div class="mb-3 row">
            <div class="col-3">
                <label for="dropdownvariable" class="form-check-label fw-bold" jhiTranslate="advance-study.attributes.descriptors">Descriptors</label>
            </div>
            <div class="col-sm-8">
                <jhi-variable-select name="dropdownvariable" id="dropdownvariable"
                                     (onVariableSelectedChange)="selectVariable($event)"
                                     [value]="variable?.id"
                                     [variableTypeIds]="VARIABLE_TYPE_IDS"
                                     [excludedVariableNames]="DEFAULT_PASSPORT_DESCRIPTORS"
                                     [disabled]="!propagateDescriptors">
                </jhi-variable-select>
            </div>
            <div class="col-sm-1">
                <button class="btn btn-info me-2" [disabled]="!propagateDescriptors" (click)="addDescriptor()">
                    <i class="fa fa-plus fa-md" aria-hidden="true"></i>
                </button>
            </div>
        </div>
        <div>
            <label class="form-check-label fw-bold" jhiTranslate="advance-study.attributes.table.title"></label>
        </div>
        <div class="border-top mb-3 mt-3"></div>
        <div class="row">
            <div class="col-md-12">
                <div class="table-responsive" style="max-height: 300px;">
                    <table class="table table-striped table-bordered table-curved table-fixed" style="max-height: 100%; overflow-y: auto;" *ngIf="selectedDescriptors.length else nodata" >
                        <thead>
                        <tr>
                            <th scope="col" jhiTranslate="advance-study.attributes.table.variable.name.column">Variable</th>
                            <th scope="col" jhiTranslate="advance-study.attributes.table.type.column">Type</th>
                            <th scope="col" jhiTranslate="advance-study.attributes.table.actions.column" class="fit">Actions</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr *ngFor="let descriptor of selectedDescriptors">
                            <td>
                                <a [routerLink]="['/', { outlets: { popup: 'variable-details-popup' }}]"
                                   [queryParams]="{ variableId: descriptor.id }">{{descriptor.name}}</a>
                            </td>
                            <td>{{descriptor.variableTypes[0].name}}</td>
                            <td class="fit">
                                <div class="d-flex justify-content-center align-items-center">
                                    <button class="btn btn-sm btn-outline-info me-2" (click)="removeFromSelectedDescriptors(descriptor)" [disabled]="!propagateDescriptors">
                                        <i class="fa fa-trash fa-md" aria-hidden="true"></i>
                                    </button>
                                </div>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                    <ng-template #nodata>
                        <table class="table table-striped table-bordered table-curved">
                            <thead>
                            <tr>
                                <th></th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                                <td jhiTranslate="no.data"></td>
                            </tr>
                            </tbody>
                        </table>
                    </ng-template>
                </div>
            </div>
        </div>
        <div class="row mb-3" *ngIf="propagateDescriptors && selectedDescriptorIds.length !== 0">
            <div class="col d-flex justify-content-end align-items-center">
                <button class="btn btn-sm btn-outline-info" (click)="saveTemplate()" >{{ 'advance-study.attributes.preset.save.setting' | translate}}</button>
            </div>
        </div>
        <div class="row mb-3">
            <div class="col-sm-12">
                <div class="form-check form-check-inline">
                    <input type="checkbox" class="form-check-input" [disabled]="!propagateDescriptors" [(ngModel)]="overrideDescriptorsLocation" id="overrideDescriptorsLocation" name="overrideDescriptorsLocation">
                    <label class="form-check-label fw-bold" for="overrideDescriptorsLocation" jhiTranslate="advance-study.attributes.override.locations"></label>
                </div>
            </div>
        </div>
        <div class="border-top mb-3"></div>
        <div class="row mb-3">
            <div class="col">
                <jhi-locations-select [(value)]="locationOverrideId" [disabled]="!propagateDescriptors || !overrideDescriptorsLocation" [showFilterOptions]="true" [isBreedingAndCountryLocationsOnly]="true"></jhi-locations-select>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" (click)="back()">
            <span jhiTranslate="entity.action.back">Back</span>
        </button>
        <button (click)="exitDescriptorsPropagationView()" [disabled]="isPropagationInvalid()" class="btn btn-primary">
            <span *ngIf="isLoading" class="throbber throbber-btn"></span>
            <span jhiTranslate="advance.continue">Continue</span>
        </button>
    </div>
}

